// 登陆页面模块
const LoginModule = r => require.ensure([], () => r(require('./login/')), 'LoginModule')

//忘记密码模块
const ForgetPwdModule = r => require.ensure([], () => r(require('./forgetPwd/')), 'ForgetPwdModule')
const ForgetPwdInput = r => require.ensure([], () => r(require('./forgetPwd/inputNumber')), 'ForgetPwdModule')
const ForgetPwdCheck = r => require.ensure([], () => r(require('./forgetPwd/checkNumber')), 'ForgetPwdModule')
const ForgetPwdSetting = r => require.ensure([], () => r(require('./forgetPwd/settingPwd')), 'ForgetPwdModule')

// 兑吧
const Duiba = r => require.ensure([], () => r(require('@/views/user/duiba/')), 'DuibaModule')

//服务条款页面模块-用户协议
const ServiceTermModule = r => require.ensure([], () => r(require('./serviceTerm')), 'ServiceTermModule')

// 用户授权模块
const AuthModule = r => require.ensure([], () => r(require('./auth')), 'AuthModule')
const BindModule = r => require.ensure([], () => r(require('./bind')), 'AuthModule')

// 在线客服
const CustomerServiceModule = r => require.ensure([], () => r(require('@/views/user/customerService')), 'CustomerServiceModule')

// 用户模块
const UserModule = r => require.ensure([], () => r(require('./')), 'UserModule')

// 注册页面模块
const RegisterModule = r => require.ensure([], () => r(require('./register/')), 'RegisterModule')
const RegisterInput = r => require.ensure([], () => r(require('./register/inputNumber')), 'RegisterModule')
const RegisterCheck = r => require.ensure([], () => r(require('./register/checkNumber')), 'RegisterModule')
const RegisterSetting = r => require.ensure([], () => r(require('./register/settingPwd')), 'RegisterModule')

export default {
  path: '/user',
  name: 'user',
  meta: {
    title: '登录注册'
  },
  component: UserModule,
  redirect: '/user/login',
  children: [{
      path: 'register',
      name: 'Register',
      redirect: '/user/register/input-number',
      meta: {
        title: '注册'
      },
      component: RegisterModule,
      children: [{
          path: 'input-number',
          meta: {
            title: '注册'
          },
          component: RegisterInput
        },
        {
          path: 'check-number/:number',
          meta: {
            title: '注册'
          },
          component: RegisterCheck
        },
        {
          path: 'setting-pwd/:number/:token',
          meta: {
            title: '注册'
          },
          component: RegisterSetting
        }
      ]
    },
    {
      path: 'auth',
      name: 'Auth',
      meta: {
        title: '登录'
      },
      component: AuthModule
    },
    {
      path: 'bind',
      name: 'Bind',
      meta: {
        title: '绑定账户'
      },
      component: BindModule
    },
    {
      path: 'login',
      name: 'Login',
      meta: {
        title: '登录'
      },
      component: LoginModule
    },
    {
      path: 'forget',
      name: 'Forget',
      redirect: '/user/forget/input-number',
      meta: {
        title: '忘记密码'
      },
      component: ForgetPwdModule,
      children: [{
          path: 'input-number',
          meta: {
            title: '忘记密码'
          },
          component: ForgetPwdInput
        },
        {
          path: 'check-number/:number',
          meta: {
            title: '忘记密码'
          },
          component: ForgetPwdCheck
        },
        {
          path: 'setting-pwd/:number/:token',
          meta: {
            title: '忘记密码'
          },
          component: ForgetPwdSetting
        }
      ]
    },
    {
      path: 'service-term',
      meta: {
        title: '用户协议'
      },
      component: ServiceTermModule
    },
    {
      path: 'duiba',
      meta: {
        title: '兑吧'
      },
      component: Duiba
    },
    {
      path: 'customer-service',
      meta: {
        title: '客服'
      },
      component: CustomerServiceModule
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/user/router.js